// src/utils/seoRouteHelper.js

/**
 * Normalize a URL pathname:
 * - ensures it starts with "/"
 * - strips query/hash (just in case)
 * - removes trailing slashes (except "/")
 */
export function normalizePathname(input = "/") {
  const raw = String(input).split("?")[0].split("#")[0] || "/";
  let path = raw.startsWith("/") ? raw : `/${raw}`;
  if (path.length > 1) path = path.replace(/\/+$/, ""); // remove trailing /
  return path;
}

/**
 * Map route path -> SEO key prefix
 * (use the keys you added: seo.home.title, seo.home.description, etc.)
 */
const SEO_ROUTE_MAP = {
  "/": "seo.home",
  "/szolgaltatasok": "seo.services",
  "/arlista": "seo.pricelist",
  "/rolunk": "seo.about",
  "/hirek": "seo.news",
  "/edzok": "seo.trainers",
  "/orarend": "seo.timetable",
  "/galeria": "seo.gallery",
  "/karrier": "seo.career",
  "/impresszum": "seo.company",
};

/**
 * Returns the SEO key prefix for the given pathname.
 * Example: "/arlista" -> "seo.pricelist"
 */
export function getSeoKeyByPath(pathname) {
  const path = normalizePathname(pathname);
  return SEO_ROUTE_MAP[path] || "seo.home";
}

/**
 * Convenience helper:
 * Returns { title, description } by calling your `t()` function.
 *
 * Usage:
 * const { title, description } = getSeoByPath(t, location.pathname);
 */

export function getSeoByPath(t, pathname) {
  const key = getSeoKeyByPath(pathname);

  const pageTitle = t(`${key}.title`);
  const brand = "ROY GYM";

  // If your translations already include "ROY GYM", you can skip this suffix.
  const title = pageTitle.includes("ROY GYM") ? pageTitle : `${pageTitle} | ${brand}`;

  return {
    key,
    title,
    description: t(`${key}.description`),
  };
}
